import { tv } from 'tailwind-variants';

const fabMainButtonStyle = tv({
  base: 'relative z-50 inline-flex items-center self-center justify-center h-12 gap-2 px-6 text-sm font-medium tracking-wide text-white transition duration-300 rounded-full whitespace-nowrap bg-primary-one hover:bg-primaryFixxer-one focus:bg-primary-three focus-visible:outline-none disabled:cursor-not-allowed disabled:border-gray-400 disabled:bg-gray-400 disabled:shadow-none',
  variants: {
    openMode: {
      hover: '',
      click: '',
    },
    open: {
      true: 'bg-primary-one',
      false: 'bg-primary-two',
    },
  },
  compoundVariants: [
    {
      openMode: 'click',
      open: true,
      className: 'rotate-45',
    },
  ],
});

const buttonListStyle = tv({
  base: 'absolute transition duration-0 ',
  variants: {
    openMode: {
      hover: 'group-hover:-translate-y-full',
      click: '',
    },
    open: {
      true: '-translate-y-full',
      false: '',
    },
    direction: {
      top: '-translate-y-full',
      right: 'translate-x-full',
      left: '-translate-x-full',
      bottom: 'translate-y-full',
    },
    defaultVariants: {
      openMode: 'hover',
    },
  },
});

const buttonListContentStyle = tv({
  base: 'relative flex transition-all',
  variants: {
    direction: {
      top: 'flex-col gap-y-4 pb-4 -translate-y-12',
      right: 'gap-x-4 pl-4 -translate-y-full',
      left: 'gap-x-4 pr-4',
      bottom: 'flex-col gap-y-4 pt-4',
    },
  },
});

const fabItemStyle = tv({
  base: 'absolute top-0 left-0 inline-flex items-center self-center justify-center w-0 h-0 gap-2 px-6 text-sm font-medium tracking-wide rounded-full scale-0 opacity-0 justify-self-center whitespace-nowrap bg-primary-two text-white hover:overflow-visible hover:duration-0 hover:bg-primaryFixxer-one focus-visible:outline-none group-hover:h-12 group-hover:w-12 group-hover:relative group-hover:opacity-100 transition duration-300 group/item',
  variants: {
    index: {
      0: 'delay-300 hover:delay-0',
      1: 'delay-200 hover:delay-0',
      2: 'delay-100 hover:delay-0',
      3: 'delay-75 hover:delay-0',
      4: 'delay-0 hover:delay-0',
    },
    openMode: {
      hover: 'group-hover:-translate-y-full',
      click: '',
    },
    open: {
      true: 'scale-100 opacity-100 w-12 h-12 relative overflow-visible',
      false: 'delay-0 opacity-0',
    },
    disabled: {
      true: 'bg-gray-400 shadow-none hover:bg-gray-400 cursor-not-allowed',
      false: '',
    },
    defaultVariants: {
      openMode: 'hover',
    },
  },
});

const fabTooltipStyle = tv({
  base: 'absolute z-2 w-0 rounded bg-slate-700 text-xs text-white opacity-0 transition-all',
  variants: {
    openMode: {
      hover: 'group-hover:w-24 group-hover:opacity-100 group-hover:right-full',
      click: '',
    },
    open: {
      true: 'w-24 p-2',
      false: 'w-0',
    },
    direction: {
      top: 'top-2 mr-2 right-full opacity-100',
      right: 'top-full mt-2 group-hover/item:opacity-100',
      left: 'top-full mt-2 group-hover/item:opacity-100',
      bottom: 'right-full mr-2 opacity-100',
    },
  },
});

export const fabStyles = {
  mainButton: fabMainButtonStyle,
  buttonList: buttonListStyle,
  buttonListContent: buttonListContentStyle,
  item: fabItemStyle,
  tooltip: fabTooltipStyle,
};
